import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class VisitsService {
  constructor(private http: HttpClientService) {}

  public createVisit(person_id: string | number, name: string): Observable<any> {
    const options = {
      nombre: name,
    };
    return this.http
      .post("/api/persons/" + person_id + "/visitas", options)
      .pipe(tap((_) => console.log("VisitsService.createVisit: Ok.")));
  }
}
